<script>
    import { fade } from 'svelte/transition';
</script>

<div in:fade={{duration:800,delay:400}} out:fade={{duration:800,delay:0}} class="container flex flex-col justify-center items-center h-full text-left mx-auto my-0">
    <h3 class="lg:text-5xl text-4xl pb-10 lg:w-1/2 w-3/4" style="line-height:1.2em"><b>Contact Me</b></h3>
    <a class="lg:text-5xl text-4xl pb-10 lg:w-1/2 w-3/4 hover:underline" href="mailto:hello@declanm.co.uk" style="">Email</a>
    <a class="lg:text-5xl text-4xl pb-10 lg:w-1/2 w-3/4 hover:underline" href="https://www.linkedin.com/in/declan-morrisroe-43abb4145/" style="">LinkedIn</a>
</div>